exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-view {\r\n  bottom: 15px;\r\n  top: 107px;\r\n  left: 0px;\r\n  right: 0px;\r\n  position: absolute;\r\n  overflow-y: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.page-inactive {\r\n  color: #444444;\r\n}\r\n\r\n.page-disable {\r\n  color: #888888;\r\n  cursor: none !important;\r\n}\r\n\r\n.page-active {\r\n  color: #2cbbc3;\r\n}\r\n\r\n.pagination-ctrl {\r\n  height: 60px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  right: 0px;\r\n  position: absolute;\r\n}\r\n\r\nh2 {\r\n  margin: 14px 0;\r\n}\r\n\r\n.directions {\r\n  font-size: 100%;\r\n}\r\n\r\n.employee-name {\r\n  font-weight: lighter;\r\n  color: #444;\r\n  max-width: 100%;\r\n}\r\n\r\n.counter {\r\n  text-align: right;\r\n  color: #2cbbc3;\r\n  font-size: 14px;\r\n  font-weight: lighter;\r\n}\r\n\r\n@media screen and (max-width: 750px) {\r\n  .directions {\r\n    font-size: 90% !important;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/components/documents/documents.component.css
// module id = ../../../../../src/app/components/documents/documents.component.css
// module chunks = main